
import { PropType } from "vue";
import { MapBuilder } from "modules/spravochnik/dt-front-page-generator/src/Map";
import { v4 as uuid } from "uuid";

export default {
    props: {
        element: {
            type: Object as PropType<object>,
        },
    },
    mounted() {
        const element = document.getElementById(this.id);
        const map = new MapBuilder(element).makeDefault();

        const geoObject = this.element?.value?.geoObject;
        if (geoObject) {
            this.$nextTick(() => {
                map.addGeoObject(JSON.parse(geoObject));
            });
        }
    },
    data() {
        return {
            id: uuid(),
        };
    },
};
